import { redirect } from '@tanstack/react-router';

export const CRUMB_TEXTS = {
  AUDIT_LOGS: 'Audit',
} as const;

export const getTitleContextSlice = (title: string, opts = { hideBreadcrumbs: false }) => ({
  getTitle: () => title,
  hideBreadcrumbs: opts.hideBreadcrumbs,
});

export const getAuditLogsTitleContextSlice = () => getTitleContextSlice(CRUMB_TEXTS.AUDIT_LOGS);

export const removeConsecutiveRepeats = <T>(ar: T[], fn: (arg: T) => string | number = item => String(item)): T[] =>
  ar.filter((item, index) => index === 0 || fn(item) !== fn(ar[index - 1]));

export function isRedirectNeeded(pathname: string, baseSegment: string, allowedNextSegments: string[] = ['edit', 'create', '']) {
  const pathParts = pathname.split('/');
  const index = pathParts.indexOf(baseSegment);

  if (index === -1 || allowedNextSegments.includes(pathParts[index + 1] || '')) {
    return { redirect: false };
  }
  const url = pathParts.slice(0, index + 1).join('/');
  return { redirect: true, url };
}

export function redirectIfNeeded(ctx: { location: { pathname: string } }, baseSegment: string) {
  const res = isRedirectNeeded(ctx.location.pathname, baseSegment);
  if (res.redirect) {
    throw redirect({ to: res.url, search: true });
  }
}
